import React from 'react'
import styled from 'styled-components'
import { useWrapperProps } from './hooks'

const Wrapper = (props: any) => {
  const { style, Component, rest } = useWrapperProps(props)
  return <Component {...rest} dir="LTR" style={style} />
}

export const RTLMainWrapper = (props: any) => {
  const { dir, style } = useWrapperProps(props)
  return <RTLMainWrapperInner {...props} $dir={dir} dir="LTR" style={style} />
}

const RTLMainWrapperInner = styled.div<{
  $dir?: 'RTL' | 'LTR'
}>`
  ${({ $dir }) =>
    $dir === 'RTL'
      ? `
    width: 100%;
    height: 100%;
  `
      : ''}
`

export const RTLListWrapper = (props: any) => <Wrapper {...props} Component={'ul'} />

const RTLWrapper = (props: any) => <Wrapper {...props} Component={'div'} />

export default RTLWrapper
